import Page from "webPage/Page";
import HeaderSwipe from "../HeaderSwipe";

let swipe;
Page.register([new RegExp('/holding-page(.php)?'), '/'], function () {
    swipe = new HeaderSwipe($(".hero"));

    setTimeout(() => swipe.begin(), 1500);
}, () => {
    swipe.destroy();
    swipe = null;
});
